import React from "react";

const DefaultTeamLogoSvg = (): JSX.Element => {
  return (
    <svg
      width="86px"
      height="68px"
      viewBox="0 0 86 68"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="r12_3a_team_report_history-copy"
          transform="translate(-62.000000, -232.000000)"
          fill="#232F3E"
          fillRule="nonzero"
        >
          <path
            d="M105,232 C98.6897978,232 93.5333333,237.242108 93.5333333,243.657138 C93.5333333,249.407371 97.6855089,254.197405 103.088889,255.132133 L103.088889,265.028586 L72.5111111,265.028586 C71.4558911,265.041215 70.6235067,266.096283 70.6,266.971443 L70.6,278.628581 L63.9111111,278.628581 C62.8619111,278.641209 62.0235067,279.696277 62,280.571437 L62,298.057144 C62,299.074423 62.9104533,300 63.9111111,300 L81.1111111,300 C82.1117689,300 83.0221267,299.074423 83.0222222,298.057144 L83.0222222,280.571437 C83.0221267,279.554157 82.1117689,278.628678 81.1111111,278.628581 L74.4222222,278.628581 L74.4222222,268.914299 L103.088889,268.914299 L103.088889,278.628581 L96.4,278.628581 C95.3508,278.641209 94.5123956,279.696277 94.4888889,280.571437 L94.4888889,298.057144 C94.4889844,299.074423 95.3993422,300 96.4,300 L113.6,300 C114.600658,300 115.511016,299.074423 115.511111,298.057144 L115.511111,280.571437 C115.511016,279.554157 114.600658,278.628678 113.6,278.628581 L106.911111,278.628581 L106.911111,268.914299 L135.577778,268.914299 L135.577778,278.628581 L128.888889,278.628581 C127.839689,278.641209 127.001284,279.696277 126.977778,280.571437 L126.977778,298.057144 C126.977873,299.074423 127.888231,300 128.888889,300 L146.088889,300 C147.089547,300 148,299.074423 148,298.057144 L148,280.571437 C148,279.554157 147.089547,278.628678 146.088889,278.628581 L139.4,278.628581 L139.4,266.971443 C139.399904,265.954163 138.489547,265.028684 137.488889,265.028586 L106.911111,265.028586 L106.911111,255.132133 C112.314491,254.197405 116.466667,249.407371 116.466667,243.657138 C116.466667,237.242108 111.310202,232 105,232 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default DefaultTeamLogoSvg;
